import { Box, FormControlLabel, Stack, Typography } from '@mui/material';
import { Switch } from 'components/switch';

export interface MultiSelectOption {
  id: string;
  label: string;
  /** Marca opcional junto a la etiqueta (P5 de Wio la usa para "· Compleja"). */
  badge?: string;
}

interface MultiSelectQuestionProps {
  options: MultiSelectOption[];
  /** Mapa `id → seleccionado`; es la forma en la que viajan estas answers. */
  value: Record<string, boolean>;
  onChange: (value: Record<string, boolean>) => void;
}

/**
 * Pregunta de selección múltiple: una fila con toggle por opción.
 *
 * NO pinta enunciado — lo pone quien la usa, con la cabecera de su sección (así lo
 * hace P5 del test de Wio). El markup viene portado tal cual de `step-block1.tsx`
 * para que ese bloque quede idéntico.
 */
export const MultiSelectQuestion = ({
  options,
  value,
  onChange,
}: MultiSelectQuestionProps) => (
  <Stack spacing={4}>
    {options.map((option) => (
      <FormControlLabel
        key={option.id}
        control={
          <Switch
            checked={!!value[option.id]}
            onChange={(_, checked) =>
              onChange({ ...value, [option.id]: checked })
            }
          />
        }
        label={
          <Typography variant="textSm" sx={{ lineHeight: 1.4, pl: 3 }}>
            {option.label}
            {option.badge && (
              <Box
                component="span"
                sx={{
                  ml: 0.75,
                  fontSize: '0.7rem',
                  color: 'warning.main',
                  fontWeight: 600,
                }}
              >
                {' '}
                {option.badge}
              </Box>
            )}
          </Typography>
        }
        sx={{ alignItems: 'center', ml: 0, mr: 0 }}
      />
    ))}
  </Stack>
);
